<div class="td-cnt-ext">
  <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" style="min-width: auto;">
    <div class="td-cnt-title">
      <span class="te-title">{{'costingTool.selectCostFromCr' | translate}}</span>
    </div>

    <div class="td-cnt-body flex-col">
      <div class="inputs-row">
        <teiasoft-input [type]="'number'"
          [labelText]="('grid.FullCost' | translate) + (fullCostUom ? ' (' + fullCostUom + ')' : '')" [isMobile]="isMobile"
          [value]="fullCost" [isRequired]="true" (onInput)="onFullCostInput($event)">
        </teiasoft-input>

        <teiasoft-input *ngIf="showAlloySurchargeInput" [type]="'number'"
          [labelText]="'grid.AlloySurchargeValue' | translate" [isMobile]="isMobile" [value]="alloySurchargeValue"
          [isRequired]="true" (onInput)="onAlloySurchargeInput($event)">
        </teiasoft-input>
      </div>
    </div>

    <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
      <teiasoft-button (onClick)="cancel()" class="mr-5" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
        [isMobile]="isMobile"></teiasoft-button>
      <teiasoft-button (onClick)="save()" class="mr-5" [type]="'tb-primary'" [text]="'commons.save' | translate"
        [isMobile]="isMobile" [disabled]="!canSave"></teiasoft-button>
    </div>
  </div>
</div>
